import { useLocation } from '@tanstack/react-router';
import { SubMenu } from 'react-pro-sidebar';

import { SidebarMenuItem } from '../SidebarMenuItem';
import { SidebarSubMenuProps } from './SidebarSubMenu.types';
import { Typography } from '../../Typography';
import { CirclePlus } from '../../icons';

export const SidebarSubMenu = ({
  item,
  openMenu,
  menuHierarchy,
  onOpenChange,
  isFirstLevel,
}: SidebarSubMenuProps) => {
  const location = useLocation();

  if (!item.items?.length)
    return (
      <SidebarMenuItem
        isFirstLevel={isFirstLevel}
        key={item.id}
        isActive={location.pathname === item.to}
        {...item}
      />
    );

  return (
    <SubMenu
      key={item.id}
      open={Boolean(item.id && menuHierarchy[openMenu]?.includes(item.id))}
      onOpenChange={() => onOpenChange(item.id || '')}
      icon={item.icon}
      component={<button type="button" />}
      label={
        <Typography variant="h5" className="!pointer-events-none underline">
          {item.label}
        </Typography>
      }
    >
      {item.items?.map((subItem) => (
        <SidebarSubMenu
          key={subItem.id}
          item={subItem}
          menuHierarchy={menuHierarchy}
          onOpenChange={(menuId) => onOpenChange(menuId)}
          openMenu={openMenu}
        />
      ))}
      {item.variant === 'infinitescroll' && item.isLoadMoreActive && (
        <SidebarMenuItem
          label="Load more"
          key="infinitescroll"
          icon={<CirclePlus role="img" size="1.2rem" className="stroke-primary-400" />}
          isActive={item.isLoadMoreActive}
          onClick={item.onLoadMore}
        />
      )}
    </SubMenu>
  );
};
